import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from "../slices/messages";
import { useState, useEffect } from "react";
import Swal from 'sweetalert2'
import { login } from "../slices/user";
import { useTranslation } from "react-i18next";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const { message, messageStatus } = useSelector((state) => state.message);
    const [submitted, setSubmitted] = useState(0);

    const [successMsg, setSuccessMsg] = useState(false);
    clearMessage()
    useEffect(() => {
        if (messageStatus == "Success") {
            setSuccessMsg(true);
        }

        
        dispatch(clearMessage());
    }, [dispatch]);


    const [inputValues, setInputValue] = useState();

    function handleChange(event) {
        const { name, value } = event.target;
        setInputValue({ ...inputValues, [name]: value });
        setSuccessMsg(false);
    }
    function handleLogin() {
        setSubmitted(1);
        dispatch(login(inputValues)).unwrap()
            .then(() => {
                navigate('/');
            })
            .catch(() => {
                setTimeout(() => {
                    dispatch(clearMessage());
                  }, 3000)
                setSubmitted(0);
            });
    }


    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="col-md-6 m-auto login-box">
                    <div className="card bg-2 login-card bg-primary-new p-6">
                        <div className="card-body p-0">
                            <div className='section-title text-center' id="heading_title">
                                <h1><span className='font-color-1'>{t('login')}</span></h1>
                                <br />
                            </div>
                            {(message && messageStatus != "Success") && (
                                <div className="col-md-12 error-section mt-2-5">
                                    <div
                                        className="alert alert-warning"
                                        role="alert"
                                    >
                                        {message}
                                    </div>
                                </div>
                            )}
                            { successMsg ?
                                <div className="col-md-12 error-section">
                                    <div className="alert alert-success" role="alert" > Registration Successfully. </div> 
                                </div>
                                :
                                ""
                            }

                            <div className="form-group">
                                <label>{t('phone_number')}</label>
                                <input type="text" className="form-control" placeholder={t('enter_phone_number')} name="phone_number" onChange={(e) => handleChange(e)} required />
                            </div>

                            <div className="form-group mb-2 mt-1-5">
                                <label>{t('password')}</label>
                                <input type="password" className="form-control" placeholder={t('enter_phone_password')} name="password" onChange={(e) => handleChange(e)} required />
                            </div>
                            <p className="text-end hide"><Link to="" className="link-text">{t('password_forgot')}</Link></p>

                            <div className="form-group text-center mt-2-new">
                                {
                                    submitted ?
                                        <button className="btn btn-primary btn-block">{t('please_wait')}</button>
                                        :
                                        <button className="btn btn-primary btn-block col-md-12" onClick={e => handleLogin()}>{t('login')}</button>
                                }
                            </div>
                            <p className="font-color text-center mt-2-new mb-0">{t('new_account')} <Link to="/register" className="link-text">{t('register')}</Link></p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default Login;